import type { SVGProps } from "react"
import { extraColors } from "../../utils/theme"
const SvgCheckboxUnchecked = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={19}
    height={18}
    fill="none"
    viewBox="0 0 19 18"
    {...props}
  >
    <rect
      width={17}
      height={17}
      x={0.912}
      y={0.5}
      fill={extraColors.dark5}
      rx={1.5}
    />
    <rect
      width={17}
      height={17}
      x={0.912}
      y={0.5}
      stroke={extraColors.dark20}
      rx={1.5}
    />
  </svg>
)
export default SvgCheckboxUnchecked
